var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoDesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 620 110",
    style: {
      enableBackground: "new 0 0 620 110"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M507.3,44.4c0-7.2-4.5-12.1-12.1-14.2c6.6-2.7,9.9-7.2,9.9-13.8c0-9.4-7.7-15.5-19.4-15.5h-31v60.3h31.5 C499.3,61.2,507.3,55.1,507.3,44.4z M468.5,13.4h16.8c4.1,0,6.5,2.1,6.5,5.2c0,3.5-2.2,5.6-6.5,5.6h-16.8V13.4z M468.5,36.6H487 c4.2,0,6.9,2.3,6.9,6c0,3.7-2.7,6-6.9,6h-18.5V36.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.1,62c17.3,0.4,32.2-14.2,31.9-31c0.3-16.8-14.6-31.4-31.9-31c-17.3-0.3-32.2,14.2-31.9,31 C555.9,47.8,570.8,62.5,588.1,62z M588.1,12.9c10.1,0,18.1,7.1,18.1,18.1c0,11-8,18.1-18.1,18.1C578,49.1,570,42.1,570,31 C570,20,578,12.9,588.1,12.9z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 525,
    y: 0.9,
    width: 13.8,
    height: 60.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.6,49.6c-9.7,0-17.9-7.2-17.9-18.5c0-11.2,7.9-18.5,17.6-18.5c8.4,0,14.5,4.9,16.2,13.3l12.7-5.7 C280.6,8.8,270.5,0,254.5,0c-17.7-0.3-32,13.7-31.6,31c0,17.8,12.4,31,31.6,31c16.5,0,27.6-9.2,31.1-24L273,32.9 C271,43,264.9,49.6,254.6,49.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.1,0.9h-23.7v60.3h24.1c19.9,0,31.9-12.3,31.9-29.7C358.4,12.8,346.5,0.9,326.1,0.9z M326.1,48.7h-9.9V13.4h9.5 c12.7,0,19,6.6,19,18.1C344.6,41.9,338.5,48.7,326.1,48.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.4,0c-17.3-0.3-32.2,14.2-31.9,31c-0.3,16.8,14.6,31.5,31.9,31c17.3,0.4,32.2-14.2,31.9-31 C437.7,14.2,422.8-0.3,405.4,0z M405.4,49.1c-10.1,0-18.1-7.1-18.1-18.1c0-11,8-18.1,18.1-18.1c10.1,0,18.1,7.1,18.1,18.1 C423.5,42.1,415.5,49.1,405.4,49.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "175.1,36.6 205.3,36.6 205.3,24.1 175.1,24.1 175.1,13.4 207.9,13.4 207.9,0.9 161.3,0.9 161.3,61.2 208.8,61.2  208.8,48.7 175.1,48.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "127.9,52 105.8,0.9 82.2,0.9 82.2,61.2 96,61.2 96,10.1 118.1,61.2 141.7,61.2 141.7,0.9 127.9,0.9  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7,0.9L0,61.2h15.1l4.7-12.5h27.7l4.7,12.5h15.1L43.5,0.9H23.7z M24.4,36.2l9.2-24.6l9.2,24.6H24.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.5,83.6c-3.5,0.3-8.1,1.2-11.5,4.3c-3.4,3.1-5.2,7.9-6,10.5c-0.8-2.5-2.6-7.4-6-10.5c-3.4-3.1-7.9-4-11.5-4.3h-63.2 l-5,12.7l62.4,0c9.8,0.4,15.5,5.7,16.3,13.6h7h0h7c0.8-7.9,6.5-13.2,16.3-13.6l62.4,0l-5-12.7H551.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDesktop);
export default __webpack_public_path__ + "static/media/logo-desktop.b9f2e5231539ca1ae5b605e2be22aff5.svg";
export { ForwardRef as ReactComponent };